import http from '@/utils/http'

// rvm 
export const updateRMachine = data => http.get('/rvm-center/api/machine/dept/notice', {
    params: data
})
//  Kg
export const updateKMachine = data => http.get('/kg-analysis/api/reject/dept/notice', {
    params: data
})
// main
export const updateMMachine = data => http.get('/maintenance-center/api/cleanrecord/dept/notice', {
    params: data
})
// file
export const updateFMachine = data => http.get('/file-center/api/ad/template/dept/notice', {
    params: data
})
// pay
export const updatePMachine = data => http.get('/kg-payment/api/dof/transaction/dept/notice', {
    params: data
})
// notice
export const updatenMachine = data => http.get('/kg-notification/api/error/email/dept/notice', {
    params: data
})

export default {
    updateRMachine,
    updateKMachine,
    updateMMachine,
    updateFMachine,
    updatePMachine,
    updatenMachine
}